import ENDPOINTS from '@/config/http/endpoints'
import type {
  CampaignLimit,
  CampaignsResponse
} from '@/ducks/campaigns/campaigns.types'
import { rootApi } from '@/ducks/root.api'

export const parseCampaignsResponse = (
  response: CampaignsResponse
): CampaignsResponse => {
  if (!response || response.status !== 1) {
    throw new Error('Failed to fetch campaigns')
  }

  return response
}

export type FetchCampaignsQueryParams = {
  page?: number
  limit?: CampaignLimit
  skip?: number
}

export const campaignsApi = rootApi.injectEndpoints({
  endpoints: build => ({
    fetchCampaigns: build.query<CampaignsResponse, FetchCampaignsQueryParams>({
      query: ({ page = 0, limit = 20, skip }) => ({
        method: 'GET',
        url: ENDPOINTS.GET_CAMPAIGNS,
        params: {
          page,
          limit,
          ...(skip != null ? { skip } : {})
        }
      }),
      transformResponse: (response: CampaignsResponse) =>
        parseCampaignsResponse(response),
      providesTags: ['Campaigns']
    })
  })
})

export const { useFetchCampaignsQuery } = campaignsApi
